import _ from 'underscore';

export default class ProductEndUsesAddDialog {
  constructor($scope, ProductService) {
    $scope.$on('show_product_end_use_add_dialog', (event, data) => {
      $scope.product_categories = data.product_categories;
      if (!$scope.product_category_id) {
        $scope.product_category_id = data.product.product_category_id;
        $scope.product_group_id = data.product.product_group_id;
      }

      $scope.product_end_uses = data.product_end_uses;

      window.openFancyboxDialog('div#product_end_use_add_dialog');
    });

    $scope.select_all_products = this.select_all_products.bind(this);
    $scope.submit = this.submit.bind(this);

    $scope.$watch('product_category_id', this.load_groups.bind(this));
    $scope.$watch('product_group_id', this.load_products.bind(this));

    this.$scope = $scope;
    this.ProductService = ProductService;
  }

  load_groups() {
    if (!this.$scope.product_category_id) {
      return;
    }

    this.$scope.products = [];

    this.ProductService.get_groups(this.$scope.product_category_id).then((data) => {
      this.$scope.product_groups = data.groups;
    });
  }

  load_products() {
    if (!this.$scope.product_group_id) {
      return;
    }

    this.ProductService.get_products(this.$scope.product_group_id).then((data) => {
      this.$scope.products = data.products;
    });
  }

  select_all_products() {
    _.each(this.$scope.products, (product) => {
      if (!product.checked) {
        product.checked = true;
      }
    });
  }

  submit() {
    const end_uses = _.where(this.$scope.product_end_uses, {checked: true});
    if (end_uses.length === 0) {
      alert('Please select at least one end use!');
      return;
    }

    const products = _.where(this.$scope.products, {checked: true});
    if (products.length === 0) {
      alert('Please select at least one product!');
      return;
    }

    this.$scope.updating = true;
    this.ProductService.add_end_uses_to_products(
      _.pluck(products, 'id'),
      _.pluck(end_uses, 'id')
    )
    .then(() => {
      this.$scope.updating = false;
    });
  }
}

ProductEndUsesAddDialog.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-end-uses-add-dialog.ctrl.js